import { forwardRef } from 'react';
import { FormikProps } from 'formik';
import ProductFormWrapper from './product-form-wrapper';
import { IProductFormValues } from '../../../../common/validations/product.validations';

interface ProductFormProps {
  onSubmit?: (values: IProductFormValues) => void | Promise<void>;
  initialValues?: IProductFormValues;
  onFormStateChange?: (values: IProductFormValues, isValid: boolean) => void;
}

const ProductForm = forwardRef<FormikProps<IProductFormValues>, ProductFormProps>(
  ({ onSubmit, initialValues, onFormStateChange }, ref) => {
    const handleSubmit = async (values: IProductFormValues) => {
      if (onSubmit) {
        await onSubmit(values);
      }
    };

    return (
      <ProductFormWrapper
        onSubmit={handleSubmit}
        initialValues={initialValues}
        onFormStateChange={onFormStateChange}
      />
    );
  }
);

ProductForm.displayName = 'ProductForm';

export default ProductForm;
